// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


// ヘッダのドロップダウン
import DropdownController from './dropdown_controller'
application.register('dropdown', DropdownController)

// アラームストップ時のモーダル表示用
import StopModalController from "./stop_modal_controller"
application.register("stop_modal", StopModalController)

// 検索機能用
import SearchController from "./search_controller"
application.register("search", SearchController)

// クリップボードにコピー用
import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

// プッシュ通知の購読処理用
import PushNotificationController from "./pwa/push_notification_controller"
application.register("push-notification", PushNotificationController)

// PWAホーム画面追加の案内モーダル用
import PwaInstallController from "./pwa/pwa_install_controller"
application.register("pwa-install", PwaInstallController)

// ダークモード・ライトモードの切り替えボタン用
import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

// フラッシュメッセージ用
import FlashController from "./flash_controller"
application.register("flash", FlashController)

// dialog要素操作用(フォーム等)
import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

// ゲーム時間管理度診断のアンケート診断フォーム用
import DiagnosisFormController from "./diagnosis_form_controller"
application.register("diagnosis-form", DiagnosisFormController)

// 定型文一覧のセクション開閉用
import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)
